import { api } from "./api";

// Admin authentication API calls
export const adminAPI = {
  // Login
  login: async (username: string, password: string) => {
    const response = await api.post("/api/admin/login", { username, password });
    if (response.success && response.data) {
      // Store session token and user info
      localStorage.setItem("adminToken", response.data.token);
      localStorage.setItem("adminUser", JSON.stringify(response.data.user));
      localStorage.setItem("adminTokenExpires", response.data.expiresAt);
      return response.data;
    }
    throw new Error(response.error || "Login failed");
  },

  // Logout
  logout: async () => {
    const token = localStorage.getItem("adminToken");
    if (token) {
      try {
        await api.post("/api/admin/logout", { token });
      } catch (error) {
        console.error("Logout error:", error);
      }
    }

    // Clear local storage
    localStorage.removeItem("adminToken");
    localStorage.removeItem("adminUser");
    localStorage.removeItem("adminTokenExpires");
  },

  // Verify session
  verifySession: async () => {
    const token = localStorage.getItem("adminToken");
    if (!token) {
      throw new Error("No session token found");
    }

    const response = await api.get("/api/admin/verify");
    if (response.success && response.data) {
      return response.data.user;
    }
    throw new Error("Invalid session");
  },

  // Check if user is authenticated
  isAuthenticated: () => {
    const token = localStorage.getItem("adminToken");
    const expires = localStorage.getItem("adminTokenExpires");

    if (!token || !expires) {
      return false;
    }

    // Check if token is expired
    const expirationTime = new Date(expires).getTime();
    const currentTime = new Date().getTime();

    return currentTime < expirationTime;
  },

  // Get current user
  getCurrentUser: () => {
    const userStr = localStorage.getItem("adminUser");
    return userStr ? JSON.parse(userStr) : null;
  },

  // User management
  getUsers: async () => {
    const response = await api.get("/api/admin/users");
    if (response.success) {
      return response.data;
    }
    throw new Error(response.error || "Failed to get users");
  },

  createUser: async (userData: any) => {
    const response = await api.post("/api/admin/users", userData);
    if (response.success) {
      return response.data;
    }
    throw new Error(response.error || "Failed to create user");
  },

  updateUser: async (id: string, userData: any) => {
    const response = await api.put(`/api/admin/users/${id}`, userData);
    if (response.success) {
      return response.data;
    }
    throw new Error(response.error || "Failed to update user");
  },

  deleteUser: async (id: string) => {
    const response = await api.delete(`/api/admin/users/${id}`);
    if (response.success) {
      return response.data;
    }
    throw new Error(response.error || "Failed to delete user");
  },

  // Activity log
  getActivityLog: async (limit = 50, offset = 0) => {
    const response = await api.get(`/api/admin/activity?limit=${limit}&offset=${offset}`);
    if (response.success) {
      return response.data;
    }
    throw new Error(response.error || "Failed to get activity log");
  },
};
